import {ApiService} from './api';

export * from './api';

export const apiProviders = [
  ApiService
];
